export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Introduza o seu texto aqui",
      conversationalPlaceholder: "Por favor, introduza a sua resposta aqui",
      conversationClosed: "Conversa encerrada.",
      conversationalDisclaimer: "As perguntas de acompanhamento serão geradas por IA com base nas suas respostas."
    },
    openText: {
      openEndPlaceholder: "Introduza o seu texto aqui"
    },
    multiText: {
      fieldPlaceholder: 'Resposta {number}',
      instruction: 'Escreva pelo menos {count} resposta abaixo, uma por caixa de texto | Escreva pelo menos {count} respostas abaixo, uma por caixa de texto',
      instructionWithoutMinimum: 'Escreva as suas respostas abaixo, uma por caixa de texto',
      minimumEntries: 'Introduza pelo menos {count} resposta para prosseguir. | Introduza pelo menos {count} respostas para prosseguir.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marca {number}',
        minimumEntries: 'Introduza pelo menos {count} marca para prosseguir. | Introduza pelo menos {count} marcas para prosseguir.'
      }
    },
    multiselect: {
      caption: "Selecione todas as opções aplicáveis"
    },
    rankOrder: {
      enterRankOrder: "Introduza a ordem de classificação",
      placeholder: "Arraste as suas escolhas para aqui para as classificar"
    },
    openNumeric: {
      label: "Numérico Aberto"
    },
    complete: {
      message: "Obrigado por responder a este inquérito."
    },
    openVideo: {
      warning: "Por favor, grave um vídeo antes de prosseguir.",
      uploadStatusUploading: "Aguarde até processarmos o seu vídeo para continuar...",
      uploadStatusSuccess: "Carregamento concluído com sucesso, pode continuar.",
      uploadStatusError: "Carregamento não concluído, tente novamente."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Introduza um e-mail válido',
      text_invalid_phone: 'Introduza um número de telefone válido',
      text_invalid_us_zip: 'Introduza um código postal válido dos EUA (ZIP)',
      text_invalid_ca_postal: 'Introduza um código postal canadiano válido',
      text_invalid_uk_postal: 'Introduza um código postal do Reino Unido válido',
      text_invalid_custom: 'Introduza um {fieldName} válido',
      text_min_chars: 'Introduza pelo menos {min} caracteres',
      text_max_chars: 'Introduza no máximo {max} caracteres',
      text_alpha_not_allowed: 'Apenas são permitidos caracteres numéricos',
      text_numeric_not_allowed: 'Apenas são permitidos caracteres alfabéticos'
    },
    external: {
      invalid: 'A resposta a esta questão não é válida.',
      required: 'Esta questão é obrigatória.',
      singlechoice_required: 'Selecionar uma opção antes de prosseguir.',
      numeric_required: 'Selecione uma avaliação antes de prosseguir.',
      text_required: 'Introduza uma resposta antes de prosseguir.',
      bigtext_required: 'Introduza uma resposta antes de prosseguir.',
      singlechoiceother_incomplete: 'Introduza uma resposta antes de prosseguir.',
      multiselectother_incomplete: 'Introduza uma resposta antes de prosseguir.',
      numeric_invalid: 'Introduza um número válido antes de prosseguir.',
      radiogrid_required: 'Selecione uma opção para cada linha antes de prosseguir.',
      incomplete: 'Responda a esta pergunta antes de continuar.',
      multiselect_min: 'Selecione pelo menos {value} opções antes de prosseguir.',
      multiselect_max: 'Selecione no máximo {value} opções antes de prosseguir.',
      multiselectother_min: 'Selecione pelo menos {value} opções antes de prosseguir.',
      multiselectother_max: 'Selecione no máximo {value} opções antes de prosseguir.',
      multiselectgrid_min: 'Selecione no mínimo {value} opções para cada linha antes de prosseguir.',
      multiselectgrid_max: 'Selecione no máximo {value} opções para cada linha antes de prosseguir.',
      rankorder_min: 'Classifique pelo menos {value} itens antes de prosseguir.',
      rankorder_max: 'Classifique no máximo {value} itens antes de prosseguir.'
    }
  }
}
